import { Separator } from "@/components/ui/separator";
import { ClientContentBlocks } from "@/components/common/content-blocks/client-content-blocks";
import { Quiz } from "@/components/common/quiz/quiz";
import { isQuizAnswered } from "../utils/content-blocks-utils";
import { groupConsecutiveNonQuizBlocks } from "@/service/content-blocks/group-consecutive-non-quiz-blocks";

export function BlocksGroup({
  blocksGroup,
  blocksGroupIndex,
  stepId,
  setCanAdvance,
  quizzes,
}: {
  blocksGroup: { title: string | null; content: ContentBlock[] };
  blocksGroupIndex: number;
  stepId: number;
  setCanAdvance: (canAdvance: boolean) => void;
  quizzes: RoadmapStepQuizProgressVM[] | undefined;
}) {
  const groupedBlocks = groupConsecutiveNonQuizBlocks(blocksGroup.content);

  return (
    <div id={`blocks-group-${blocksGroupIndex}`}>
      {blocksGroupIndex > 0 && <Separator className="my-10" />}
      <div className="bg-remedium-blue/10 mb-2.5 flex h-6 w-6 items-center justify-center rounded-full text-sm font-semibold text-black">
        {blocksGroupIndex + 1}
      </div>
      {blocksGroup.title && (
        <h2 className="mb-2.5 text-xl font-semibold md:max-w-[80%]">
          {blocksGroup.title}
        </h2>
      )}

      {groupedBlocks.map((group, groupIndex) =>
        group.type === "quiz" ? (
          <Quiz
            key={group.blocks[0].data.uuid}
            quiz={group.blocks[0].data}
            setCanAdvance={setCanAdvance}
            stepIdx={groupIndex}
            completedEvent="roadmap_step_quiz"
            resourceId={stepId}
            readonly={isQuizAnswered(group.blocks[0], quizzes)}
          />
        ) : (
          <ClientContentBlocks
            key={`content-${groupIndex}`}
            blocks={group.blocks}
            theme="roadmap_step"
          />
        ),
      )}
    </div>
  );
}
